// extracted by css-extract-rspack-plugin
export default {"cls1":"ChatInterface-cls1_iwQ","cls2":"ChatInterface-cls2_4g_ ChatInterface-cls1_iwQ"};